import { timeout } from 'data-layer-cr/dist/utils';
import localData from './localRequestData.json';

type ParsedData = { [key: string]: Record<string, unknown> };

/**
 * A mock client which will return responses present in localRequestData.json
 *
 * @param method - The HTTP method
 * @param url - The target url
 */
async function LocalNetworkClient<T>(method: string, url: string): Promise<T> {
  await timeout(3000);
  const methodData = (localData as ParsedData)[method];
  if (typeof methodData === 'undefined') {
    throw new Error('Method not defined');
  }
  const [validUrl] = url.split('?');
  const urlData = (methodData as ParsedData)[validUrl];
  if (typeof urlData === 'undefined') {
    throw new Error('URL undefined');
  }
  return urlData as T;
}
export default LocalNetworkClient;
